import Select, { SingleValue } from 'react-select';
import { hooks as commonHooks } from '@sitebuilder/common';

interface PropsShape {
    id: string;
    label: string;
    options: {
        label: string;
        value: string;
        selected: boolean;
    }[];
    onChange: (value: string) => void;
    dataContext: any;
}

export default function FilterDropdown(props: PropsShape) {
    const { onChange, dataContext } = props;
    const labelId = `dropdown-${props.id}-label`;
    const selectedValue: {
        label: string;
        value: string;
        selected: boolean;
    } = props.options.reduce((memo: any, o) => {
        if (o.selected) memo.push(o);

        return memo;
    }, []);

    const handleChange = (
        selectedOption: SingleValue<{ label: string; value: string; selected: boolean }>
    ) => {
        if (selectedOption?.value) {
            onChange(selectedOption.value);
        }
    };

    const i18n = commonHooks.useLocalization();

    return (
        <label id={labelId} className="filter-dropdown-wrapper">
            <span
                className="filter-dropdown-label-text"
                dangerouslySetInnerHTML={{ __html: i18n.format(props.label, dataContext) }}
            />

            <Select
                aria-labelledby={labelId}
                className="filter-dropdown"
                classNamePrefix={'dropdown'}
                onChange={handleChange}
                options={props.options}
                placeholder={i18n.translate('widgets_fundList_filters_selectPlaceHolder') as any}
                styles={{
                    // Fixes the overlapping problem of the component
                    // https://github.com/JedWatson/react-select/issues/1085#issuecomment-632718713
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
                    control: (provided) => ({ ...provided, border: 'none', borderRadius: 0 }),
                }}
                value={selectedValue}
            />
        </label>
    );
}
